// this mixin is explicitly for components that use BaseListCard for displaying the card.
// It defines methods to force calling collapse/expand on the baseListCard.  You need to
// do 3 things to implement this:
// 1. import this mixin
// 2. put this in the list of mixins for the component
// 3. add 'ref="baseCard"' to the BaseListCard, so the "this.$refs.baseCard..." call
// will find the reference
export default {
  methods: {
    forceCollapse() {
      this.$refs.baseCard.forceCollapse();
    },
    forceExpand() {
      this.$refs.baseCard.forceExpand();
    },
  },
};
